export default function verifyLeadingLang (string, lang) {
  if (lang === 'en') {
    return string.startsWith('/en/') ? string : `/en${string}`
  } else {
    return string.startsWith('/en/') ? string.substr(3) : string
  }
}



// WEBPACK FOOTER //
// ./client/util/verifyLeadingLang.js